/*
 * cluutch-univers.js
 * La barre d'univers mobile (sections/cluutch-univers.liquid), deux petits offices, chargé en
 * `defer` par la section :
 * 1. l'onglet actif est amené en vue à l'arrivée quand la barre déborde (les six onglets font
 *    357 px à gouttières de 20 : ils tiennent à 390, la barre défile de 10 px à 375 ; décision
 *    du 21/09) : un défilement de la barre seule (`scrollTo` sur la nav, jamais `scrollIntoView`,
 *    qui ferait défiler la page), sec, à l'arrivée ;
 * 2. le réglage « se cacher en descendant, revenir en remontant » (`data-cluutch-univers-cache`
 *    posé par la section quand il est coché) : un observateur de direction, une classe. La barre
 *    reste visible en haut de page et dès que le doigt remonte ; elle glisse sous l'en-tête en
 *    descendant.
 * Auteur : Cluutch / Studio Hogo.
 */
(function () {
  if (window.cluutchUniversReady) return;
  window.cluutchUniversReady = true;

  var section = document.querySelector('.cluutch-univers-section');
  if (!section) return;

  // 1. L'onglet actif en vue, si la barre déborde : recalé à gauche sur la gouttière (le
  //    scroll-padding de la feuille), sans dépasser la fin de la barre.
  var barre = section.querySelector('.cluutch-univers');
  var actif = barre && barre.querySelector('[aria-current="page"]');
  if (barre && actif && barre.scrollWidth > barre.clientWidth) {
    var gouttiere = parseFloat(getComputedStyle(barre).paddingLeft) || 0;
    var cible = Math.max(0, Math.min(actif.offsetLeft - gouttiere, barre.scrollWidth - barre.clientWidth));
    barre.scrollTo({ left: cible, behavior: 'auto' });
  }

  // 2. Le réglage « se cache au défilement » : la nav porte l'attribut (Liquid), la section
  //    l'enveloppe `.shopify-section`, que Liquid n'atteint pas, le reçoit ici (la transition
  //    de la feuille le cible).
  if (!barre || !barre.hasAttribute('data-cluutch-univers-cache')) return;
  section.setAttribute('data-cluutch-univers-cache', '');
  var precedent = window.scrollY;
  var SEUIL = 8;   // un frémissement du doigt ne bascule pas la barre

  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (Math.abs(y - precedent) < SEUIL) return;
    section.classList.toggle('est-cachee', y > precedent && y > 120);
    precedent = y;
  }, { passive: true });
})();
